import { render } from "./Sims.vue?vue&type=template&id=d314ab74&scoped=true"
import script from "./Sims.vue?vue&type=script&lang=js"
export * from "./Sims.vue?vue&type=script&lang=js"

import "./Sims.vue?vue&type=style&index=0&id=d314ab74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d314ab74"]])

export default __exports__